
// NOTE: submitRating() and getAverageRating() were removed. They targeted
// /ratings/client/rate and /ratings/statistique/... — routes belonging to the
// old meethousepros service, which no longer exist (404/403 in production).
// Ratings are derived from customer feedback; feedback is the way in.
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../config/api-endpoints';
import { Rating, RatingRequest, AverageRatingResponse } from '../models';
export { RatingRequest } from '../models';

@Injectable({ providedIn: 'root' })
export class RatingService {

  constructor(private http: HttpClient) {}

  getServiceRatings(): Observable<Rating[]> {
    return this.http.get<Rating[]>(`rating:${API_ENDPOINTS.RATINGS.SERVICE_RATINGS}`);
  }



  getStaffRatings(pageNo: number = 0, pageSize: number = 50): Observable<Rating[]> {
    return this.http.get<Rating[]>(`rating:${API_ENDPOINTS.RATINGS.STAFF_RATINGS}`, {
      params: { pageNo: pageNo.toString(), pageSize: pageSize.toString() }
    });
  }
}
